import * as React from 'react';
import SvgIcon from 'ha/components/SvgIcon';

interface Props {
  iconName: string;
  text: string;
}

const SupplyPageIcon: React.SFC<Props> = ({ iconName, text }) => (
  <div className="flexbox flex-align-center">
    <SvgIcon name={iconName} className="flex-shrink-0 icon-3 m-r-1_5" />
    <div className="text-bold font-size-md">{text}</div>
  </div>
);

export default SupplyPageIcon;
